'use client';

import { createContext, type ReactNode, useContext } from 'react';

import { useTeamConfig } from '@/app/(football)/[team]/_context/context';

import { topCollectorConfig } from './config';
import type { TopCollectorPageConfig } from './types';

const TopCollectorPageConfigContext = createContext<TopCollectorPageConfig | null>(null);

interface Props {
  children: ReactNode;
}

export function TopCollectorPageConfigProvider({ children }: Props) {
  const { teamSlug } = useTeamConfig();
  const pageConfig = topCollectorConfig[teamSlug];

  return <TopCollectorPageConfigContext.Provider value={pageConfig}>{children}</TopCollectorPageConfigContext.Provider>;
}

export function useTopCollectorPageConfig() {
  const context = useContext(TopCollectorPageConfigContext);

  if (!context) {
    throw new Error('useTopCollectorPageConfig must be used within TopCollectorPageConfigProvider');
  }

  return context;
}
